import React from 'react';
import '../../stylesheets/components/NotFound.scss';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import SearchBar from '../SearchBar/index.jsx';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const NotFound = ({ t, i18n }) => {
  let lang = i18n.language;

  const toggleSearch = () => {
    const clickEvent = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    });
    const myButton = document.getElementById('mobile-search-icon');
    myButton.dispatchEvent(clickEvent);
  };

  return (
    <main>
      <div
        className={`${
          typeof window !== 'undefined' && !window.location.href.includes('v2')
            ? 'sc-pages-404-v2'
            : ''
        } sc-pages-404`}
      >
        <div className="error-page-content">
          <h1>404 error</h1>
          <h2>{t("We can't seem to find that page.")}</h2>
          <p>
            {t('notFound_Para1')}&nbsp; <br />
            <a href={_.withLocale(lang, '/')}>{t('Return home')}</a>&nbsp;
            {t('notFound_Para2')}
          </p>
        </div>

        <div className="searchContainer">
          <div className="innerContainerNotFound">
            <div className="homepage-new desktop-only">
              <h2>{t('Find discounts for your prescriptions')}</h2>
              <SearchBar
                buttonPlaceHolder={t('Search')}
                showZipCode={false}
                aria={{ 'aria-labelledby': 'memberSearchPrescription' }}
              />
            </div>
            <div className="mobile-search mobile-only">
              <h2>{t('Find discounts for your prescriptions')}</h2>
              <button
                onClick={() => toggleSearch()}
                className="input-search open-search-mobile mobile-only whiteFocus"
              >
                {/*<span className="sc-icon sc-icon-search input-search--icon" />*/}
                <span className="input-search--placeholder">
                  <LazyLoadImage
                    alt=""
                    src="/content/images/icons/searchIconGray.svg"
                    className="searchImg"
                    height="24"
                    width="24"
                  />
                  {t('Type your drug name')}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default withRouter(withTranslation()(NotFound));
